import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children, requireEmailVerified = true, require2FA = true, requireCardOnFile = false, allowedRoles = [] }) => {
  const { user, userProfile, loading, profileLoading, isEmailVerified, is2FAEnabled, hasCardOnFile, userRole } = useAuth();

  // Show loading state
  if (loading || profileLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
          <p className="text-foreground-secondary">Loading...</p>
        </div>
      </div>
    );
  }

  // Not authenticated
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Email not verified
  if (requireEmailVerified && !isEmailVerified) {
    return <Navigate to="/verify-email-required" replace />;
  }

  // 2FA not enabled — enforce unconditionally when require2FA=true (H-06).
  // Previously gated on twofa_setup_deadline being set, which let users with
  // no deadline skip 2FA entirely. Deadline is now only advisory (UI reminder);
  // enforcement is hard-blocked here.
  if (require2FA && !is2FAEnabled) {
    return <Navigate to="/2fa-setup-required" replace />;
  }

  // Card not on file for trial users
  if (requireCardOnFile && !hasCardOnFile && userProfile?.role === 'client') {
    return <Navigate to="/card-required" replace />;
  }

  // Role-based access control
  if (allowedRoles?.length > 0 && !allowedRoles?.includes(userRole)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

export default ProtectedRoute;